import React, { useState } from "react";
import Classes from "./style.module.css";
import logo from "../../../assets/Logo.png";
import hamburger from "../../../assets/menu.png";
import { CSSTransition } from "react-transition-group";
import { Backdrop } from "../../../Components/Index";

const Header = () => {
  const [menu, setmenu] = useState(false);
  const toggleSetMenu = () => {
    setmenu((prev) => !prev);
  };
  return (
    <>
      {menu && <Backdrop close={toggleSetMenu} />}
      <div className={Classes.header}>
        <nav className={`${Classes.header_box} ${Classes.left}`}>
          <p className={Classes.header_item}>Home</p>
          <p className={Classes.header_item}>Rooms</p>
          <p className={Classes.header_item}>Wedding</p>
          <p className={Classes.header_item}>In The Area</p>
          <img className={Classes.header_logo} src={logo} alt="Logo" />
        </nav>
        <nav className={`${Classes.header_box} ${Classes.right}`}>
          <p className={Classes.header_item}>Local Dining</p>
          <p className={Classes.header_item}>Gallery</p>
          <p className={Classes.header_item}>Rates</p>
          <p className={Classes.header_item}>Contact</p>
          <img
            className={Classes.header_menu}
            onClick={toggleSetMenu}
            src={hamburger}
            alt="Hamburger"
          />
        </nav>
      </div>
      <CSSTransition
        in={menu}
        unmountOnExit
        mountOnEnter
        timeout={{ enter: 50, exit: 300 }}
        classNames={{
          enter: Classes.show,
          enterActive: Classes.showactive,
          enterDone: Classes.showdone,
        }}
      >
        <div className={Classes.header_sidemenu}>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>Home</p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>Rooms</p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>Wedding</p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>
            In The Area
          </p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>
            Local Dining
          </p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>Gallery</p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>Rates</p>
          <p className={`${Classes.header_item} ${Classes.mobile}`}>Contact</p>
        </div>
      </CSSTransition>
    </>
  );
};

export default Header;
